import React from 'react'
import { ProfileTypes } from 'types/enums'

import { MainWrapper } from 'components/MainWrapper'
import { FlexContainer } from 'components/Flex'
import { useTriage } from 'hooks/useTriage'

import { Heading } from '../Heading'
import { Filters } from '../Filters'
import { TriageTable } from '../Table/TriageTable'
import { LastRefreshDate } from '../LastRefreshDate'

export const Analysis = () => {
  const { data, lastRefreshAt } = useTriage(
    'formalization',
    ProfileTypes.Consultant,
  )

  return (
    <MainWrapper>
      <FlexContainer column maxWidth="1008px" style={{ marginBottom: '45px' }}>
        <Heading profileType={ProfileTypes.Consultant} />
        <Filters />
        <LastRefreshDate date={lastRefreshAt} />
        <TriageTable data={data} />
      </FlexContainer>
    </MainWrapper>
  )
}
